// How much of the bottom of the screen a fixed bar takes up, so the launcher
// can sit above it. On a phone property page that bar is the booking drawer,
// and its right-hand end is the "Update Quote" / "Book Now" button.
//
// Visibility is read from getClientRects(), not offsetParent. The drawer is
// position: fixed, and offsetParent is always null for a fixed element,
// visible or not, so checking it measured every drawer as 0 and the launcher
// sat on the booking button. A display:none bar (the drawer above the md
// breakpoint) has no client rects.
export function bottomBarHeight(bar) {
  if (!bar || bar.getClientRects().length === 0) return 0
  return Math.round(bar.getBoundingClientRect().height)
}
